import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components';

export function NewWillMinorBeneficiariesScreen() {
  const navigate = useNavigate();

  const handleCancel = useCallback(() => {
    navigate('../asset-summary');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../pet-arrangements');
  }, [ navigate ]);

  return (
    <div className="new-will-asset-summary-screen">
      <h2>Minor Beneficiaries</h2>
      <p>Select how to handle minor beneficiaries</p>
      <div className="button-container">
        <Button onClick={handleCancel}>Back</Button>
        <Button onClick={handleNext}>Continue</Button>
      </div>
    </div>
  );
}
